/** Espelha status_item_conferencia (db_compras): resultado de um item ao concluir a contagem. */
export enum StatusItemConferenciaEnum {
  Pendente = 1,
  Conforme = 2,
  Divergente = 3,
}
